import React from 'react';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from '@atlaskit/button/new';
import { Props } from 'modules/addon/VisualAddonPage';
import t from 'modules/i18n/intl';

import config from 'appconfig';
import { Dimensions, Font } from 'components/visuals';
import { getSoftwareProduct } from 'data/products';
import { useSelector } from 'react-redux';
import { selectMarketplaceAddon } from 'modules/catalog/addons';
import { State } from 'model/State';

const CloudWrapper = styled.div`
  font-family: ${Font.family};
  padding: ${Dimensions.units(2)}px;
  font-size: 16px;
`;

type WithDisabled = { disabled: boolean };

const TextWrapper = styled.p<WithDisabled>`
  color: ${(props) => (props.disabled ? token('color.text.disabled', '#626F86') : 'inherit')};
`;

const ButtonWrapper = styled.div`
  margin: 12px 0 0 0;
`;

const CloudAddonConfiguration = ({ data }: Props) => {
  const selectedAddon = useSelector((state) =>
    selectMarketplaceAddon(state as State, {
      productKey: data.productKeys[0],
    }),
  );

  const disabled = Boolean(getSoftwareProduct(data.productKeys[0])?.isDisabled);

  const macAddonLink = selectedAddon?._result
    ? `${config.marketplaceUrl}${selectedAddon?._result?._links?.alternate?.href}`
    : config.marketplaceUrl;

  return (
    <CloudWrapper>
      <TextWrapper disabled={disabled}>
        <FormattedMessage
          id="addon.cloud.add-to-site.text"
          values={{
            addon: data.pricing[0].productDescription,
          }}
        />
      </TextWrapper>
      <ButtonWrapper>
        <LinkButton
          href={macAddonLink}
          appearance="primary"
          isDisabled={disabled}
          data-cy="add-to-site-button"
        >
          {t('addon.cloud.add-to-site.cta')}
        </LinkButton>
      </ButtonWrapper>
    </CloudWrapper>
  );
};

export default CloudAddonConfiguration;
